

























// import React, { useState, useEffect } from "react";
// import { nigeriaStates, workTypes } from "../../assets/jobData";
// import { toast } from "sonner";
// import qs from "query-string";
// import { useNavigate } from "react-router-dom";
// import { useFetchData } from "../../hooks/useFtechData";

// // Simulated Paystack payment function (replace with actual Paystack integration)
// const initiatePaystackPayment = () => {
//   return new Promise((resolve) => {
//     // Simulate Paystack payment success after 2 seconds
//     setTimeout(() => resolve({ status: "success", transactionId: "TXN123456" }), 2000);
//   });
// };

// const SearchBox = () => {
//   const [searchParams, setSearchParams] = useState("job");
//   const [formData, setFormData] = useState({});
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [showMoreDetails, setShowMoreDetails] = useState(false);
//   const navigate = useNavigate();

//   // Fetch jobseekers when searching by name
//   const { data: jobseekers, loading: jobseekersLoading } = useFetchData(
//     formData.jobseekerName && searchParams === "candidate"
//       ? `${process.env.REACT_APP_API_URL}jobSeeker/allJobSeeker?name=${formData.jobseekerName}`
//       : null
//   );

//   const handleSelection = (e, selection) => {
//     e.preventDefault();
//     setSearchParams(selection);
//     setFormData({}); // Reset form data when switching search type
//     setIsModalOpen(false); // Close modal when switching
//     setShowMoreDetails(false); // Reset details view
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//     if (name === "jobseekerName" && value && searchParams === "candidate") {
//       setIsModalOpen(true); // Open modal when typing in jobseeker name
//     } else {
//       setIsModalOpen(false); // Close modal if input is cleared
//     }
//   };

//   const handleFind = async (e) => {
//     e.preventDefault();

//     const { jobTitle, workType, state, city, jobseekerName } = formData;

//     if (!jobTitle && !workType && !state && !city && !jobseekerName) {
//       return toast.error("Kindly fill at least one search field");
//     }

//     const queryParams = {
//       ...(jobTitle && { jobTitle }),
//       ...(state && { state }),
//       ...(city && { city }),
//       ...(workType && { workType }),
//       ...(jobseekerName && { jobseekerName }),
//       searchType: searchParams,
//     };

//     const queryString = qs.stringify(queryParams);
//     if (searchParams === "job") {
//       navigate(`/jobs?${queryString}`);
//       return;
//     }
//     if (searchParams === "candidate") {
//       navigate(`/candidate?${queryString}`);
//       setIsModalOpen(false); // Close modal on search
//       return;
//     }
//   };

//   const handleJobseekerSelect = (jobseekerId) => {
//     navigate(`/profile/${jobseekerId}`);
//     setIsModalOpen(false);
//     setFormData({}); // Clear form after selection
//   };

//   const handleViewMore = async (jobseekerId) => {
//     try {
//       const paymentResult = await initiatePaystackPayment();
//       if (paymentResult.status === "success") {
//         setShowMoreDetails(true); // Show more details after payment
//         toast.success("Payment successful! View more details below.");
//         // Navigate to a detailed view or display additional data (simulated here)
//         console.log(`Viewing more details for jobseeker ${jobseekerId}`);
//       }
//     } catch (error) {
//       toast.error("Payment failed. Please try again.");
//     }
//   };

//   return (
//     <div className="mt-20">
//       <div className="flex flex-col items-center gap-8 mt-24 text-center text-white">
//         <h1 className="text-4xl font-bold">
//           The Easiest Way To Get Your New Job
//         </h1>
//         <h3 className="text-xl">
//           Search 270 new jobs.{" "}
//           <span className="text-lg">0 added in the last 24 hours</span>
//         </h3>

//         <form className="flex flex-col items-center gap-4 w-full sm:w-3/5 p-6 rounded-lg shadow-lg">
//           <div className="flex mb-1 gap-1">
//             <button
//               onClick={(e) => handleSelection(e, "job")}
//               className={`px-4 py-2 text-white hover:bg-orange-600 ${
//                 searchParams === "job"
//                   ? "bg-orange-500"
//                   : "bg-white-500 border-[2px]"
//               } transition-colors`}
//             >
//               FIND A JOB
//             </button>
//             <button
//               onClick={(e) => handleSelection(e, "candidate")}
//               className={`px-4 py-2 text-white hover:bg-orange-600 ${
//                 searchParams === "candidate"
//                   ? "bg-orange-500"
//                   : "bg-white-500 border-[2px]"
//               } transition-colors`}
//             >
//               FIND A CANDIDATE
//             </button>
//           </div>

//           <div className="w-full md:flex md:flex-row md:items-center md:gap-4 relative ">
//             {/* Desktop-specific layout */}
//             <div className="hidden md:flex md:flex-row md:items-center md:w-full md:gap-4 p-4 bg-white rounded-lg shadow-lg">
//               <div className="flex-1 p-2">
//                 <input
//                   className="p-2 w-full border-none outline-none text-gray-600 placeholder-gray-400"
//                   type="text"
//                   placeholder={searchParams === "job" ? "e.g., Web Developer" : "e.g., John Doe"}
//                   onChange={handleChange}
//                   name={searchParams === "job" ? "jobTitle" : "jobseekerName"}
//                   id={searchParams === "job" ? "jobTitle" : "jobseekerName"}
//                   value={formData[searchParams === "job" ? "jobTitle" : "jobseekerName"] || ""}
//                 />
//               </div>
//               <div className="flex-1 p-2 ">
//                 <select
//                   onChange={handleChange}
//                   className="p-2 w-full border-none outline-none text-gray-600 bg-transparent"
//                   name="workType"
//                   id="workType"
//                   value={formData.workType || ""}
//                 >
//                   <option value="">Category</option>
//                   {workTypes &&
//                     workTypes.map((eachType, index) => (
//                       <option key={index} value={eachType}>
//                         {eachType}
//                       </option>
//                     ))}
//                 </select>
//               </div>
//               <div className="flex-1 p-2">
//                 <select
//                   onChange={handleChange}
//                   className="p-2 w-full border-none outline-none text-gray-600 bg-transparent"
//                   name="state"
//                   id="state"
//                   value={formData.state || ""}
//                 >
//                   <option value="">State</option>
//                   {nigeriaStates &&
//                     nigeriaStates.map((eachState, index) => (
//                       <option key={index} value={eachState}>
//                         {eachState}
//                       </option>
//                     ))}
//                 </select>
//               </div>
//               {formData.state && (
//                 <div className="flex-1 p-2">
                
//                     <input
//                   className="p-2 w-full border-none outline-none text-gray-600 placeholder-gray-400"
//                   type="text"
//                 placeholder='city (optional)'
//                   onChange={handleChange}
//                    name="city"
//                     id="city"
//                   value={formData.city || ""}
//                 />
                
//                 </div>
//               )}
//               <button
//                 onClick={handleFind}
//                 className="bg-orange-500 text-white px-4 py-2 rounded-md hover:bg-orange-600 transition-colors"
//               >
//                 Search
//               </button>
//             </div>

//             {/* Mobile layout (unchanged) */}
//             <div className="md:hidden flex flex-col items-center gap-4 w-full">
//               <input
//                 className="p-2 mb-0 text-gray-600 w-full border-2 border-gray-300 rounded-md outline-none focus:border-orange-500 transition-colors"
//                 type="text"
//                 placeholder={searchParams === "job" ? "e.g. Web Developer" : "e.g., John Doe"}
//                 onChange={handleChange}
//                 name={searchParams === "job" ? "jobTitle" : "jobseekerName"}
//                 id={searchParams === "job" ? "jobTitle" : "jobseekerName"}
//                 value={formData[searchParams === "job" ? "jobTitle" : "jobseekerName"] || ""}
//               />

//               {isModalOpen && searchParams === "candidate" && (
//                 <div className="absolute top-full left-0 mt-1 w-full bg-white rounded-lg shadow-lg z-10 max-h-64 overflow-y-auto">
//                   {jobseekersLoading ? (
//                     <div className="p-4 text-gray-600">Loading...</div>
//                   ) : jobseekers?.length > 0 ? (
//                     jobseekers.map((jobseeker) => (
//                       <div
//                         key={jobseeker._id}
//                         className="p-4 text-gray-900 border-b border-gray-200 flex justify-between items-center"
//                       >
//                         <span>
//                           {jobseeker.firstName} {jobseeker.middleName || ""} {jobseeker.lastName}
//                         </span>
//                         <button
//                           onClick={() => handleViewMore(jobseeker._id)}
//                           className="text-blue-500 hover:text-blue-700 ml-4"
//                         >
//                           View More
//                         </button>
//                       </div>
//                     ))
//                   ) : (
//                     <div className="p-4 text-gray-600">No jobseekers found</div>
//                   )}
//                   {showMoreDetails && (
//                     <div className="p-4 text-gray-900 bg-gray-100 mt-2">
//                       More details: Email: {jobseekers[0]?.email || "N/A"}, Phone: {jobseekers[0]?.phone || "N/A"}
//                     </div>
//                   )}
//                 </div>
//               )}

//               <div className="flex flex-row gap-4 w-full">
//                 <select
//                   onChange={handleChange}
//                   className="p-2 mb-4 w-full text-gray-600 border-2 border-gray-300 rounded-md outline-none focus:border-orange-500 transition-colors"
//                   name="workType"
//                   id="workType"
//                   value={formData.workType || ""}
//                 >
//                   <option value="">Category</option>
//                   {workTypes &&
//                     workTypes.map((eachType, index) => (
//                       <option key={index} value={eachType}>
//                         {eachType}
//                       </option>
//                     ))}
//                 </select>

//                 <select
//                   onChange={handleChange}
//                   className="p-2 text-gray-600 mb-4 w-full border-2 border-gray-300 rounded-md outline-none focus:border-orange-500 transition-colors"
//                   name="state"
//                   id="state"
//                   value={formData.state || ""}
//                 >
//                   <option value="">State</option>
//                   {nigeriaStates &&
//                     nigeriaStates.map((eachState, index) => (
//                       <option key={index} value={eachState}>
//                         {eachState}
//                       </option>
//                     ))}
//                 </select>
//               </div>

//               {formData.state && (
//                 <select
//                   onChange={handleChange}
//                   className="p-2 mb-4 w-full text-gray-600 border-2 border-gray-300 rounded-md outline-none focus:border-orange-500 transition-colors"
//                   name="city"
//                   id="city"
//                   value={formData.city || ""}
//                 >
//                   <option value="">City (optional)</option>
//                   {/* Example cities - replace with dynamic data if available */}
//                   <option value="Lagos">Lagos</option>
//                   <option value="Ibadan">Ibadan</option>
//                   <option value="Abuja">Abuja</option>
//                 </select>
//               )}

//               <button
//                 onClick={handleFind}
//                 className="bg-orange-500 px-6 py-2 text-white rounded-md hover:bg-orange-600 transition-colors"
//               >
//                 Search
//               </button>
//             </div>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default SearchBox;












import React, { useState, useEffect } from "react";
import { nigeriaStates, workTypes } from "../../assets/jobData";
import { toast } from "sonner";
import qs from "query-string";
import { useNavigate, Link } from "react-router-dom";
import { useFetchData } from "../../hooks/useFtechData";
import axios from "axios";
import { Clock } from "lucide-react";
// Simulated Paystack payment function (replace with actual Paystack integration)
const initiatePaystackPayment = () => {
  return new Promise((resolve) => {
    // Simulate Paystack payment success after 2 seconds
    setTimeout(() => resolve({ status: "success", transactionId: "TXN123456" }), 2000);
  });
};

const SearchBox = () => {
  const [searchParams, setSearchParams] = useState("job");
  const [recentJobsCount, setRecentJobsCount] = useState(0);
  const [formData, setFormData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  const [showJobsModal, setShowJobsModal] = useState(false); // ← NEW: for job search results modal
  const [filteredJobs, setFilteredJobs] = useState([]);      // ← NEW: filtered job results
  const [jobsLoading, setJobsLoading] = useState(false);     // ← NEW
  const [jobsError, setJobsError] = useState(null);          // ← NEW
  const [loading, setLoading] = useState(false)
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();


     useEffect(() => {
  const fetchRecentJobsTotal = async () => {
    try {
      setLoading(true);

      // Fetch from both endpoints
      const [recentRes, allJobsRes] = await Promise.all([
        fetch(`${process.env.REACT_APP_API_URL}job/recent`),
        axios.get(`${process.env.REACT_APP_API_URL}admin`)
      ]);

      let recentCount = 0;
      let allJobsCount = 0;

      // 1. From /job/recent endpoint
      if (recentRes.ok) {
        const recentData = await recentRes.json();
        recentCount = recentData.jobs?.length || recentData.count || 0;
      }

      // 2. From /admin endpoint (all jobs)
      if (allJobsRes.data) {
        const allJobs = allJobsRes.data;
        
        // Filter jobs posted in last 24 hours
        const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000);

        const recentFromAll = allJobs.filter(job => {
          const jobDate = new Date(job.createdAt || job.created_at);
          return jobDate >= twentyFourHoursAgo;
        });

        allJobsCount = recentFromAll.length;
      }

      // Sum both sources
      const totalRecentJobs = recentCount + allJobsCount;

      setJobs(allJobsRes.data); // Keep original jobs for display if needed
      setRecentJobsCount(totalRecentJobs); // New state for the count

      console.log(`Total jobs in last 24 hours: ${totalRecentJobs}`);

    } catch (err) {
      console.error("Failed to fetch recent jobs total", err);
    } finally {
      setLoading(false);
    }
  };

  fetchRecentJobsTotal();
}, []);



  // Fetch jobseekers when searching by name (your original logic - untouched)
  const { data: jobseekers, loading: jobseekersLoading } = useFetchData(
    formData.jobseekerName && searchParams === "candidate"
      ? `${process.env.REACT_APP_API_URL}jobSeeker/allJobSeeker?name=${formData.jobseekerName}`
      : null
  );

  const handleSelection = (e, selection) => {
    e.preventDefault();
    setSearchParams(selection);
    setFormData({}); // Reset form data when switching search type
    setIsModalOpen(false); // Close modal when switching
    setShowMoreDetails(false); // Reset details view
    setShowJobsModal(false); // Also close job results modal
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "jobseekerName" && value && searchParams === "candidate") {
      setIsModalOpen(true); // Open modal when typing in jobseeker name
    } else {
      setIsModalOpen(false); // Close modal if input is cleared
    }
  };

const handleFind = async (e) => {
  e.preventDefault();
  const { jobTitle, workType, state, city, jobseekerName } = formData;

  if (!jobTitle && !workType && !state && !city && !jobseekerName) {
    return toast.error("Kindly fill at least one search field");
  }

  const queryParams = {
    ...(jobTitle && { jobTitle }),
    ...(state && { state }),
    ...(city && { city }),
    ...(workType && { workType }),
    ...(jobseekerName && { jobseekerName }),
    searchType: searchParams,
  };

  const queryString = qs.stringify(queryParams);

  // ── JOB SEARCH ── Real backend fetch + frontend filter
  if (searchParams === "job") {
    setJobsLoading(true);
    setJobsError(null);
    setShowJobsModal(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}job/jobs?${queryString}`);
      if (!response.ok) throw new Error("Failed to fetch jobs");

      const data = await response.json();
      console.log(data); // ← Check structure: is it data.alljobs or data.data?

      // Assuming structure is { data: [...] } or { alljobs: [...] }
      const allJobs = data.alljobs || data.data || data || [];

      // ← NEW: Filter on frontend
      const filtered = allJobs.filter(job => {
        const matchesTitle = formData.jobTitle ? 
          job.jobTitle?.toLowerCase().includes(formData.jobTitle.toLowerCase()) : true;
        const matchesWorkType = formData.workType ? 
          job.workType === formData.workType : true;
        const matchesState = formData.state ? 
          job.state === formData.state : true;
        const matchesCity = formData.city ? 
          job.localGovernment?.toLowerCase().includes(formData.city.toLowerCase()) : true;

        return matchesTitle && matchesWorkType && matchesState && matchesCity;
      });

      setFilteredJobs(filtered);
    } catch (err) {
      setJobsError(err.message || "Something went wrong");
      toast.error("Failed to load jobs");
    } finally {
      setJobsLoading(false);
    }

    return;
  }

  // ── CANDIDATE SEARCH ── your original logic (untouched)
  if (searchParams === "candidate") {
    navigate(`/candidate?${queryString}`);
    setIsModalOpen(false);
    return;
  }
};
  const handleJobseekerSelect = (jobseekerId) => {
    navigate(`/profile/${jobseekerId}`);
    setIsModalOpen(false);
    setFormData({}); // Clear form after selection
  };

  const handleViewMore = async (jobseekerId) => {
    try {
      const paymentResult = await initiatePaystackPayment();
      if (paymentResult.status === "success") {
        setShowMoreDetails(true);
        toast.success("Payment successful! View more details below.");
        console.log(`Viewing more details for jobseeker ${jobseekerId}`);
      }
    } catch (error) {
      toast.error("Payment failed. Please try again.");
    }
  };

  // Helper to format time ago (you can replace with your own)
  const getTimeAgo = (date) => {
    const now = new Date();
    const diff = now - new Date(date);
    const minutes = Math.floor(diff / 60000);
    if (minutes < 60) return `${minutes} min ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hr${hours > 1 ? 's' : ''} ago`;
    return `${Math.floor(hours / 24)} day${Math.floor(hours / 24) > 1 ? 's' : ''} ago`;
  };

  return (
    <div className="mt-20">
      <div className="flex flex-col items-center gap-8 mt-24 text-center text-white">
        <h1 className="text-4xl font-bold"> The Easiest Way To Get Your New Job </h1>
        <h3 className="text-xl">
          Search 270 new jobs.{" "}
          {/* <div className="flex items-center gap-3 mb-6">
  <Clock className="text-emerald-600" size={28} />
  <h2 className="text-3xl font-bold">
    {recentJobsCount} Jobs Posted in Last 24 Hours
  </h2>
</div> */}
          <span className="text-lg"> {recentJobsCount} jobs added in the last 24 hours</span>
        </h3>

        <form className="flex flex-col items-center gap-4 w-full sm:w-3/5 p-6 rounded-lg shadow-lg">
          <div className="flex mb-1 gap-1">
            <button
              onClick={(e) => handleSelection(e, "job")}
              className={`px-4 py-2 text-white hover:bg-orange-600 ${
                searchParams === "job" ? "bg-orange-500" : "bg-white-500 border-[2px]"
              } transition-colors`}
            >
              FIND A JOB
            </button>
            <button
              onClick={(e) => handleSelection(e, "candidate")}
              className={`px-4 py-2 text-white hover:bg-orange-600 ${
                searchParams === "candidate" ? "bg-orange-500" : "bg-white-500 border-[2px]"
              } transition-colors`}
            >
              FIND A CANDIDATE
            </button>
          </div>

          <div className="w-full md:flex md:flex-row md:items-center md:gap-4 relative">
            {/* Desktop-specific layout */}
            <div className="hidden md:flex md:flex-row md:items-center md:w-full md:gap-4 p-4 bg-white rounded-lg shadow-lg">
              <div className="flex-1 p-2">
                <input
                  className="p-2 w-full border-none outline-none text-gray-600 placeholder-gray-400"
                  type="text"
                  placeholder={searchParams === "job" ? "e.g., Web Developer" : "e.g., John Doe"}
                  onChange={handleChange}
                  name={searchParams === "job" ? "jobTitle" : "jobseekerName"}
                  id={searchParams === "job" ? "jobTitle" : "jobseekerName"}
                  value={formData[searchParams === "job" ? "jobTitle" : "jobseekerName"] || ""}
                />
              </div>
              <div className="flex-1 p-2">
                <select
                  onChange={handleChange}
                  className="p-2 w-full border-none outline-none text-gray-600 bg-transparent"
                  name="workType"
                  id="workType"
                  value={formData.workType || ""}
                >
                  <option value="">Category</option>
                  {workTypes &&
                    workTypes.map((eachType, index) => (
                      <option key={index} value={eachType}>
                        {eachType}
                      </option>
                    ))}
                </select>
              </div>
              <div className="flex-1 p-2">
                <select
                  onChange={handleChange}
                  className="p-2 w-full border-none outline-none text-gray-600 bg-transparent"
                  name="state"
                  id="state"
                  value={formData.state || ""}
                >
                  <option value="">State</option>
                  {nigeriaStates &&
                    nigeriaStates.map((eachState, index) => (
                      <option key={index} value={eachState}>
                        {eachState}
                      </option>
                    ))}
                </select>
              </div>
              {formData.state && (
                <div className="flex-1 p-2">
                  <input
                    className="p-2 w-full border-none outline-none text-gray-600 placeholder-gray-400"
                    type="text"
                    placeholder="city (optional)"
                    onChange={handleChange}
                    name="city"
                    id="city"
                    value={formData.city || ""}
                  />
                </div>
              )}
              <button
                onClick={handleFind}
                className="bg-orange-500 text-white px-4 py-2 rounded-md hover:bg-orange-600 transition-colors"
              >
                Search
              </button>
            </div>

            {/* Mobile layout (unchanged) */}
            <div className="md:hidden flex flex-col items-center gap-4 w-full">
              <input
                className="p-2 mb-0 text-gray-600 w-full border-2 border-gray-300 rounded-md outline-none focus:border-orange-500 transition-colors"
                type="text"
                placeholder={searchParams === "job" ? "e.g. Web Developer" : "e.g., John Doe"}
                onChange={handleChange}
                name={searchParams === "job" ? "jobTitle" : "jobseekerName"}
                id={searchParams === "job" ? "jobTitle" : "jobseekerName"}
                value={formData[searchParams === "job" ? "jobTitle" : "jobseekerName"] || ""}
              />

              {isModalOpen && searchParams === "candidate" && (
                <div className="absolute top-full left-0 mt-1 w-full bg-white rounded-lg shadow-lg z-10 max-h-64 overflow-y-auto">
                  {jobseekersLoading ? (
                    <div className="p-4 text-gray-600">Loading...</div>
                  ) : jobseekers?.length > 0 ? (
                    jobseekers.map((jobseeker) => (
                      <div
                        key={jobseeker._id}
                        className="p-4 text-gray-900 border-b border-gray-200 flex justify-between items-center"
                      >
                        <span>
                          {jobseeker.firstName} {jobseeker.middleName || ""} {jobseeker.lastName}
                        </span>
                        <button
                          onClick={() => handleViewMore(jobseeker._id)}
                          className="text-blue-500 hover:text-blue-700 ml-4"
                        >
                          View More
                        </button>
                      </div>
                    ))
                  ) : (
                    <div className="p-4 text-gray-600">No jobseekers found</div>
                  )}

                  {showMoreDetails && (
                    <div className="p-4 text-gray-900 bg-gray-100 mt-2">
                      More details: Email: {jobseekers[0]?.email || "N/A"}, Phone: {jobseekers[0]?.phone || "N/A"}
                    </div>
                  )}
                </div>
              )}

              <div className="flex flex-row gap-4 w-full">
                <select
                  onChange={handleChange}
                  className="p-2 mb-4 w-full text-gray-600 border-2 border-gray-300 rounded-md outline-none focus:border-orange-500 transition-colors"
                  name="workType"
                  id="workType"
                  value={formData.workType || ""}
                >
                  <option value="">Category</option>
                  {workTypes &&
                    workTypes.map((eachType, index) => (
                      <option key={index} value={eachType}>
                        {eachType}
                      </option>
                    ))}
                </select>

                <select
                  onChange={handleChange}
                  className="p-2 text-gray-600 mb-4 w-full border-2 border-gray-300 rounded-md outline-none focus:border-orange-500 transition-colors"
                  name="state"
                  id="state"
                  value={formData.state || ""}
                >
                  <option value="">State</option>
                  {nigeriaStates &&
                    nigeriaStates.map((eachState, index) => (
                      <option key={index} value={eachState}>
                        {eachState}
                      </option>
                    ))}
                </select>
              </div>

              {formData.state && (
                <select
                  onChange={handleChange}
                  className="p-2 mb-4 w-full text-gray-600 border-2 border-gray-300 rounded-md outline-none focus:border-orange-500 transition-colors"
                  name="city"
                  id="city"
                  value={formData.city || ""}
                >
                  <option value="">City (optional)</option>
                  <option value="Lagos">Lagos</option>
                  <option value="Ibadan">Ibadan</option>
                  <option value="Abuja">Abuja</option>
                </select>
              )}

              <button
                onClick={handleFind}
                className="bg-orange-500 px-6 py-2 text-white rounded-md hover:bg-orange-600 transition-colors"
              >
                Search
              </button>
            </div>
          </div>
        </form>
      </div>

      {/* ── NEW: Jobs Results Modal ── */}
      {showJobsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl w-full max-w-5xl max-h-[90vh] overflow-y-auto shadow-2xl">
            {/* Header */}
            <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between z-10">
              <h2 className="text-2xl font-bold text-gray-800">
                {filteredJobs.length} Job{filteredJobs.length !== 1 ? "s" : ""} Found
              </h2>
              <button
                onClick={() => setShowJobsModal(false)}
                className="text-gray-500 hover:text-gray-800 text-2xl"
              >
                ×
              </button>
            </div>

            {/* Body */}
            <div className="p-6 space-y-6">
              {jobsLoading ? (
                <div className="text-center py-12">
                  <div className="animate-spin w-12 h-12 border-4 border-orange-500 border-t-transparent rounded-full mx-auto"></div>
                  <p className="mt-4 text-gray-600">Loading jobs...</p>
                </div>
              ) : jobsError ? (
                <div className="text-center py-12 text-red-600">
                  {jobsError}
                </div>
              ) : filteredJobs.length === 0 ? (
                <div className="text-center py-12 text-gray-600">
                  No jobs found matching your criteria
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {filteredJobs?.map((job, index) => (
                    <div
                      key={job._id || index}
                      className="bg-gray-50 p-5 border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow"
                    >
                      <div className="flex items-start justify-between">
                        <div>
                          <h3 className="text-lg font-semibold text-gray-900">{job.jobTitle}</h3>
                        </div>
                        <span className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
                          {job.workType}
                        </span>
                      </div>

                      <div className="mt-3 text-sm text-gray-600 space-y-1">
                        <p className="font-semibold">
                          <span className="text-orange-500">★</span> {job.localGovernment || "—"}, {job.state || "—"}
                        </p>
                        <p>Experience Level: {job.experienceLength || "Not specified"}</p>
                        <p>Posted: {getTimeAgo(job.createdAt)}</p>
                        <span className="font-semibold">
                          Salary: {job.salary || "Negotiable"} {job.currency || ""}
                        </span>
                      </div>

                      <div className="mt-5 flex justify-end">
                        <Link
                          to={`/job/${job._id}`}
                          className="px-6 py-2.5 bg-orange-500 text-white font-medium rounded-md hover:bg-orange-600 transition-colors shadow-sm"
                        >
                          Apply Now
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBox;

























